export default {
    'name': 'play_m',
    'width': '64',
    'height': '64',
    'viewBox': '0 0 64 64',
    'data': '<path d=\'M52.7864 29.4078C54.7728 30.5651 54.7728 33.4349 52.7864 34.5922L18.8191 54.3815C16.8191 55.5467 14.3089 54.104 14.3089 51.7893L14.3089 12.2107C14.3089 9.89602 16.8191 8.45332 18.8191 9.6185L52.7864 29.4078Z\' fill=\'#FF4171\'/>'
}
